module.exports = __webpack_public_path__ + "media/images/official/top_mv1_pc-419c9c1fb7f1bf173cea3fbf016d498a.jpg";